import React from 'react';
import {Button} from './../button';
import {IDateTime} from '../helpers';
import {Scroll} from './../scroll-fade';
import {Reaction, TThumbDirection} from './../thumb';
import {Dropdown} from '../dropdown';
import {Emoticons} from '../forms';
import {TReactionType} from '../thumb/reaction';

export interface IFeedbackAnswersProps {
    answers: IAnswerProps[]
    className?: string
}

export interface IAnswerProps {
    direction: TThumbDirection;
    reactionType?: TReactionType;
    text: string;
    time?: IDateTime;
    onHasSeenCheck?: (checked: boolean) => void;
    hasSeen?: boolean;
    titleTooltip?: string | JSX.Element;
    className?: string;
    commentToolTip?: string | JSX.Element;
}

const FeedbackAnswers = (props: IFeedbackAnswersProps): JSX.Element => (
    <Scroll>
        <ul className="feedback-answers__results">
            {props.answers.map((answer: IAnswerProps, i: number) => (
                <li className="feedback-answers__answer" key={i}>
                    <div className="feedback-answers__answer-inner">
                        <div className="feedback-answers__column feedback-answers__column--thumb">
                            {answer.reactionType === 'talk-bubble' ? <Reaction type={'talk-bubble'} /> : <Reaction direction={answer.direction} />}
                        </div>
                        <div className="feedback-answers__column">
                            {answer.time && <time className="feedback-answers__time" dateTime={answer.time.iso}>{answer.time.value}</time>
                            }
                            { answer.commentToolTip ?
                                <Dropdown
                                    trigger={{children: <Button
                                        text={answer.text}
                                        showEmoticons={true}
                                        className="button--style-link"
                                    />}}>
                                    {answer.commentToolTip}
                                </Dropdown> : <p className="feedback-answers__text"><Emoticons text={answer.text}/></p>}
                        </div>
                        {answer.hasSeen !== undefined &&
                            <div className="feedback-answers__column feedback-answers__column--thumb">
                                <Dropdown
                                    delayShow={200}
                                    offset={[-10, 17]}
                                    trigger={{children: <Button
                                        text=""
                                        onClick={answer.onHasSeenCheck ? (): void => answer.onHasSeenCheck!(!answer.hasSeen) : undefined}
                                        className="feedback-answers__favorite-button"
                                        color="white"
                                        icon={answer.hasSeen ? 'check-green' : 'check-red'}
                                    />}}>
                                    {answer.titleTooltip}
                                </Dropdown>
                            </div>
                        }
                    </div>
                </li>
            ))}
        </ul>
    </Scroll>);

export default FeedbackAnswers;
